import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkDataMultimediaFileForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsLinkDataMultimediaFile = ({
  editable = true,
  multimediaFileLinkData,
  multimediaFileLinkMetadata,
  forceValidation,
  multimediaFileLinkDataChange,
  multimediaFileLinkDataValidate,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.multimediaFile.title')}</h3>
    <LinkDataMultimediaFileForm
      editable={editable}
      forceValidation={forceValidation}
      multimediaFileLinkData={multimediaFileLinkData}
      multimediaFileLinkMetadata={multimediaFileLinkMetadata}
      onChange={multimediaFileLinkDataChange}
      onValidate={multimediaFileLinkDataValidate}
      shouldIgnoreMandatoryValidation
    />
  </>
);

export default IncidentDetailsLinkDataMultimediaFile;
